import { FC } from 'react';
import EditSupplierSidePanelContainer from 'src/sections/manage_suppliers/EditSupplierSidePanelContainer';
import { ManageSupplier } from 'src/types/manage-suppliers/ManageSupplier';
import { useContextSelector } from 'use-context-selector';
import { ViewCatalogsContext } from './ViewCatalogsContext';

export interface CatalogSupplierInfoSidePanelProps {
  supplier?: ManageSupplier | null;
  isOpen?: boolean;
  onClose?: () => void;
  onSaveSuccess?: () => void | Promise<void>;
  openProgramInfo?: (catalogProgramId: string) => void;
}

const CatalogSupplierInfoSidePanel: FC<CatalogSupplierInfoSidePanelProps> = ({
  supplier: supplierProp,
  isOpen: isOpenProp,
  onClose: onCloseProp,
  onSaveSuccess,
  openProgramInfo: openProgramInfoProp,
}) => {
  const contextIsOpen = useContextSelector(ViewCatalogsContext, (s) => s.isSupplierInfoPanelOpen);
  const contextSupplierInfo = useContextSelector(ViewCatalogsContext, (s) => s.supplierInfo);
  const contextCloseSupplierInfo = useContextSelector(ViewCatalogsContext, (s) => s.closeSupplierInfo);
  const contextOpenProgramInfo = useContextSelector(ViewCatalogsContext, (s) => s.openProgramInfo);

  const useExternalSource = supplierProp != null || isOpenProp != null;

  const isOpen = useExternalSource ? Boolean(isOpenProp) : contextIsOpen;
  const supplier = useExternalSource ? supplierProp ?? null : contextSupplierInfo ?? null;
  const closeSupplierInfo = onCloseProp ?? contextCloseSupplierInfo;
  const openProgramInfo = openProgramInfoProp ?? contextOpenProgramInfo;

  // The upsert mutation already invalidates manageSuppliers queries on success,
  // so no extra invalidation here (it caused a duplicate Filter request).
  return (
    <EditSupplierSidePanelContainer
      supplier={supplier}
      isOpen={isOpen}
      onClose={closeSupplierInfo}
      onSaveSuccess={onSaveSuccess}
      onProgramInfoClick={openProgramInfo}
      viewUntilEdit
    />
  );
};

export default CatalogSupplierInfoSidePanel;
